/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CheckoutDisabledButtonState Input Action
 */
export class CheckoutDisabledButtonStateInput implements Msdyn365.IActionInput {
    // CheckoutDisabledButtonState: Construct the input needed to run the action
    constructor() {}

    // CheckoutDisabledButtonState: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CheckoutDisabledButtonState`;
    public getCacheObjectType = () => 'CheckoutDisabledButtonState';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// CheckoutDisabledButtonState: Create a data model here or import one to capture the response of the action
export interface ICheckoutDisabledButtonStateData {
    disabled: boolean;
}

/**
 * CheckoutDisabledButtonState: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CheckoutDisabledButtonStateInput();
};

/**
 * CheckoutDisabledButtonState: Use this function to call your action and process the results as needed
 */
async function action(input: CheckoutDisabledButtonStateInput, ctx: Msdyn365.IActionContext): Promise<ICheckoutDisabledButtonStateData> {
    return { disabled: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckoutDisabledButtonStateData>>action,
    // CheckoutDisabledButtonState: Give your data action a unique id
    id: 'CheckoutDisabledButtonState',
    input: createInput
    // CheckoutDisabledButtonState: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
